// extracted by mini-css-extract-plugin
export default {"debugPanel":"DebugPanel__debugPanel___NlbO7","button":"DebugPanel__button___Hm_Dp","buttonText":"DebugPanel__buttonText___DEz3h","activeButton":"DebugPanel__activeButton___LZwRS"};